"use strict";
/* @ngInject */
function navigationMenuService(API_URL, $http) {
    return function (tenantId, district) {
        var districtStr = district ? "/district" : "";
        return $http.get("" + API_URL.navigation + districtStr + "/" + tenantId)
            .then(function (response) {
            return response.data;
        });
    };
}
exports.navigationMenuService = navigationMenuService;



/** WEBPACK FOOTER **
 ** ./app/common/top-nav/navigation-menu.service.ts
 **/